import { infosPratiquesData } from '../../../mocks/infos-pratiques';

export default function InfosPratiques() {
  return (
    <section className="relative py-24 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif text-gray-900 mb-4">
            Infos Pratiques
          </h2>
          <p className="text-xl text-gray-600 font-light">
            Tout ce qu'il faut savoir
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {infosPratiquesData.map((section, index) => (
            <div
              key={index}
              className="bg-white/70 backdrop-blur-lg border border-gray-200/60 rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-2xl mb-5">
                <i className={`${section.icon} text-2xl text-emerald-700`}></i>
              </div>
              
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                {section.title}
              </h3>
              
              <ul className="space-y-2">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-emerald-600 text-lg mt-0.5"></i>
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}